export const PinIconSet = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.5 14.5L3 21"
      fill="black"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 9.48574L14.1924 18.6782L15.8894 16.9811L15.4973 13.1949L21.0064 8.52156L15.1567 2.67188L10.4833 8.1808L6.69706 7.78869L5 9.48574Z"
      fill="black"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
